import React, { useContext } from "react";
import { LanguageContext, text } from "../../container/language";
import { useTranslation } from "react-i18next";

const SingleFeature = ({ icon, feature, description, down = false }) => {
  const { userLanguage } = useContext(LanguageContext);
  return (
    <div
      className="card-features__item"
      style={down ? { display: "block" } : {}}
    >
      <div className="card-features__item-icon">
        <div className="card-features__item-icon__shape">
          <i className={`fa fa-${icon}`}></i>
        </div>
      </div>
      <div
        className="card-features__item-text"
        style={down ? { paddingLeft: 0, paddingTop: "10px" } : {}}
      >
        {feature && (
          <p>
            <small>
              <font>
                <font>{text(feature, userLanguage)}</font>
              </font>
            </small>
          </p>
        )}
        <p>
          <font>
            <font>{description && text(description, userLanguage)}</font>
          </font>
        </p>
      </div>
    </div>
  );
};

export default SingleFeature;
